export default __webpack_public_path__ + "locales/az/EmptyTrashDialog.json?hash=3bdf79089e6830440e56f2f6ac45da1e";